import { render, staticRenderFns } from "./DialogListaArmarios.vue?vue&type=template&id=4a717cb8"
import script from "./DialogListaArmarios.vue?vue&type=script&lang=js"
export * from "./DialogListaArmarios.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports